import PropTypes from 'prop-types';
import { useMutation, useApolloClient } from '@apollo/client';
import { formatIsoDate, addDays } from '../../../Helpers/dateFormatter';
import ReplaceDayMutation from './ReplaceDayMutation';
import DailyDietPlanQuery from '../Fetch/DailyDietPlanQuery';
import clearShoppingListCache from '../../ShoppingList/clearShoppingListCache';

const ReplaceDayConnectorApollo = ({ children, date }) => {
  const client = useApolloClient();

  const [replaceDay, { data, loading, error }] = useMutation(ReplaceDayMutation, {
    awaitRefetchQueries: true,
    refetchQueries: [
      {
        query: DailyDietPlanQuery,
        variables: {
          date: formatIsoDate(date),
          canBeCopiedToDate: formatIsoDate(addDays(date, 1)),
        },
      },
    ],
  });

  const createReplaceDay = async ({ replacementId }) => {
    const response = await replaceDay({
      variables: {
        request: {
          date: formatIsoDate(date),
          replacementId,
        },
      },
    });

    clearShoppingListCache(client);

    return response;
  };

  return children({
    replaceDay: {
      replace: createReplaceDay,
      response: data,
      loading,
      error,
    },
  });
};

ReplaceDayConnectorApollo.propTypes = {
  children: PropTypes.func.isRequired,
  date: PropTypes.instanceOf(Date).isRequired,
};

export default ReplaceDayConnectorApollo;
